import React from "react";

export default function SelectField({ id, label, required, value, onChange, options = [], name }) {
  return (
    <div>
      <label htmlFor={id} style={{ display: 'block', marginBottom: 8, fontWeight: 500, color: '#374151' }}>
        {label} {required && <span style={{ color: '#dc2626' }}>*</span>}
      </label>
      <select id={id} name={name} value={value} onChange={(e) => onChange?.(name || id, e.target.value)}
              style={{ width:'100%', padding:'0.75rem', border:'1px solid #d1d5db', borderRadius:8, fontSize:'1rem' }}>
        <option value="">Select</option>
        {options.map((opt) => (
          <option key={opt.value || opt} value={opt.value || opt}>{opt.label || opt}</option>
        ))}
      </select>
    </div>
  );
}